export const CALENDLY_URL = 'https://calendly.com';
export const DEFAULT_COUNTRY_NAME = 'Netherlands';
export const NETHERLANDS_COUNTRY_CODE = '+31';
export const MEP_FACEBOOK_URL = 'https://www.facebook.com/miseenplaceNL/?fref=ts';
export const MEP_INSTAGRAM_URL = 'https://www.instagram.com/miseenplace.nl/';
export const MEP_TIKTOK_URL = 'https://www.tiktok.com/@miseenplace.nl';
export const MAQQIE_CORE_LOGIN_URL = '/Maqqie/index_mep.html#/auth_login?email=';
export const MAQQIE_APP_LOGIN_URL_WITH_TOKEN = '/Maqqie/index_mep.html?token=';
export const MEP_WEB_PAGE_URL = 'https://www.miseenplace.nl';
export const MEP_STRING = 'MEP';
export const NL_STRING = 'nl';
